module.exports = __webpack_public_path__ + "14ff2909fb558a82fa7b2739d301e7c4.pdf";